import type {
    IReferenceToken,
    IReferenceTokenPayload,
} from '../../common/interfaces/cis/profile';
import {
    axiosDelete,
    get,
    post,
    put,
} from '../utility/Requests';
import { getIdentityBaseRoute } from './IdentityServiceUtils';

export const referenceTokenUrl = `/api/identity/ReferenceToken`;

// Helper function to get direct Identity service URL
const getDirectReferenceTokenUrl = (partitionGlobalId: string, isHostMode: boolean = false) =>
    `${getIdentityBaseRoute(partitionGlobalId, isHostMode)}/api/ReferenceToken`;

export interface IReferenceTokenFilterOpts {
    userSearchTerm: string;
    top: number;
    skip: number;
    sortBy: string;
    sortOrder: 'asc' | 'desc';
}

export function getReferenceToken(partitionGlobalId: string, isHostMode: boolean = false) {
    const directUrl = getDirectReferenceTokenUrl(partitionGlobalId, isHostMode);
    return get<IReferenceToken[]>(directUrl, { ignoreBasePath: true });
}

export function getAllReferenceTokens({
    partitionGlobalId, opts, isHostMode = false,
}: { url: string; partitionGlobalId: string; opts: IReferenceTokenFilterOpts; isHostMode?: boolean }) {
    const paginationMap = new URLSearchParams(opts as Record<string, any>);
    const directUrl = `${getDirectReferenceTokenUrl(partitionGlobalId, isHostMode)}/partition/${partitionGlobalId}?${paginationMap.toString()}`;
    return get<{ totalCount: number; results: IReferenceToken[] }>(directUrl, { ignoreBasePath: true });
}

export function generateReferenceToken(payload: IReferenceTokenPayload, partitionGlobalId: string, isHostMode: boolean = false) {
    const directUrl = getDirectReferenceTokenUrl(partitionGlobalId, isHostMode);
    return post<string>(directUrl, {
        body: payload,
        ignoreBasePath: true,
    });
}

export function deleteReferenceToken(referenceTokenId: string, partitionGlobalId: string, isHostMode: boolean = false) {
    const directUrl = `${getDirectReferenceTokenUrl(partitionGlobalId, isHostMode)}/${referenceTokenId}`;
    return axiosDelete(directUrl, { ignoreBasePath: true });
}

export function deleteReferenceTokens(partitionGlobalId: string, tokenIds: string[], isHostMode: boolean = false) {
    const directUrl = getDirectReferenceTokenUrl(partitionGlobalId, isHostMode);
    return axiosDelete(directUrl, {
        body: {
            partitionGlobalId,
            tokenIds,
        },
        ignoreBasePath: true,
    });
}

export function deleteReferenceTokenByValue(partitionGlobalId: string, tokenValue: string, isHostMode: boolean = false) {
    const directUrl = `${getDirectReferenceTokenUrl(partitionGlobalId, isHostMode)}/Revoke`;
    return axiosDelete(directUrl, {
        body: {
            partitionGlobalId,
            referenceToken: tokenValue,
        },
        ignoreBasePath: true,
    });
}

export function regenerateReferenceToken(referenceTokenId: string, payload: { expiration: string }, partitionGlobalId: string, isHostMode: boolean = false) {
    const directUrl = `${getDirectReferenceTokenUrl(partitionGlobalId, isHostMode)}/${referenceTokenId}`;
    return put<string>(directUrl, {
        body: payload,
        ignoreBasePath: true,
    });
}
